<div>
    <div *ngIf="!openPolicyForm">
        <div class="Tabletitle">
            <span class="Tabletitle"> Policies ({{policiesCount}}) </span>
        </div>

        <div class="row">
            <button class="actionButton m-1" mat-raised-button (click)="createPolicy($event)">Create
                Policy</button>
            <div class="input-group-sm mt-2 input-group col-6">
                <input *ngIf="allPolicies" class="form-control" type="search" (keyup)="applyFilter($event)"
                    placeholder="Filter">
            </div>
            <!-- <mat-form-field class="element-filter" *ngIf="allPolicies">
                <mat-label>Filter</mat-label>
                <input matInput (keyup)="applyFilter($event)">
            </mat-form-field> -->
            <!-- <div class="m-1 mt-1" *ngIf=allPolicies style="float:right">
                (Total Count: {{policiesCount}})
            </div> -->
        </div>

        <div *ngIf="!allPolicies && noPolicies">
            No policies to display
        </div>

        <div *ngIf="allPolicies" class="table-container mat-elevation-z8">

            <table mat-table matSort [dataSource]="allPolicies" matSortActive="name" matSortDirection="asc"
                aria-describedby="policy-table">

                <!--- Note that these columns can be defined in any order.
            The actual rendered columns are set as a property on the row definition"-->

                <!-- Hold Name Column -->
                <ng-container matColumnDef="name">
                    <th id="name" mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
                    <td mat-cell *matCellDef="let policy"> {{policy.name}}
                        <mat-icon title="Descripion" style="transform: scale(0.75);" #authMenu
                            [matMenuTriggerFor]="menu">
                            info</mat-icon>
                        <mat-menu class="my-menu pl-2 p-1" #menu="matMenu">
                            {{policy.description}}
                        </mat-menu>
                    </td>
                </ng-container>

                <!-- Type Column -->
                <ng-container matColumnDef="type">
                    <th id="type" mat-header-cell *matHeaderCellDef mat-sort-header> Type </th>
                    <td mat-cell *matCellDef="let policy"> {{policy.type}} </td>
                </ng-container>

                <!-- Duration Column -->
                <ng-container matColumnDef="duration">
                    <th id="duration" mat-header-cell *matHeaderCellDef mat-sort-header> Duration </th>
                    <td mat-cell *matCellDef="let policy"> {{policy.duration}} </td>
                </ng-container>

                <!-- Date Column -->
                <ng-container matColumnDef="date">
                    <th id="date" mat-header-cell *matHeaderCellDef mat-sort-header> Date </th>
                    <td mat-cell *matCellDef="let policy"> {{policy.date | date}} </td>
                </ng-container>

                <!-- Active Column -->
                <ng-container style="align-items: center;" matColumnDef="active">                 
                        <th id="active" *matHeaderCellDef class="mat-header-sortless"> Active </th>
                        <td mat-cell *matCellDef="let policy">
                            <mat-icon *ngIf="policy.active">check</mat-icon>
                        </td>
                </ng-container>

                <!-- Action Column -->
                <ng-container style="align-items: center;" matColumnDef="actions">
                    <th id="action" *matHeaderCellDef class="mat-header-sortless"> Actions </th>
                    <td mat-cell *matCellDef="let policy">
                        <mat-icon title="Update Policy" (click)="updatePolicy($event, policy)">edit
                        </mat-icon>
                        <!-- <button mat-icon-button aria-label="Delete" title="Delete Policy" (click)="deletePolicy($event, policy.id)"
              style="font-size: 15px;">
              <mat-icon>delete</mat-icon>
            </button> -->
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

            </table>
            <mat-paginator [pageSizeOptions]="[10, 20, 50]" [pageSize]="10" showFirstLastButtons></mat-paginator>
        </div>
    </div>


    <div *ngIf="openPolicyForm">
        <div class="sticky-top">
            <div class="Tabletitle">{{dialogData.title}}</div>
        </div>
        <div *ngIf="!policyCreated && !policyUpdated">
            <form #initiateForm="ngForm">
                <div class="card-body">
                    <div class="input-group-sm mb-3 input-group col-12">
                        <div class="input-group-prepend">
                            <span class="input-group-text form-label-105">Name</span>
                        </div>
                        <input name="name" class="form-control" type="text" [(ngModel)]="dialogData.name" required>
                    </div>
                    <div class="input-group-sm mb-3 input-group col-12">
                        <div class="input-group-prepend">
                            <span class="input-group-text form-label-105">Type</span>
                        </div>
                        <mat-select #policyType name="policy-type" placeholder="Type" [(ngModel)]="dialogData.type"
                            class="form-control" required>
                            <mat-option value="Duration">Duration</mat-option>
                            <mat-option value="Fixed">Fixed</mat-option>
                        </mat-select>
                    </div>

                    <div *ngIf="dialogData.type=='Duration'" class="input-group">
                        <div class="input-group-sm mb-3 input-group col">
                            <div class="input-group-prepend">
                                <span class="input-group-text form-label-105">Years</span>
                            </div>
                            <input class="form-control" name="years" type="text" [(ngModel)]="dialogData.duration.years"
                                required>
                        </div>

                        <div class="input-group-sm mb-3 input-group col">
                            <div class="input-group-prepend">
                                <span class="input-group-text form-label-105">Months</span>
                            </div>
                            <input class="form-control" name="months" type="text"
                                [(ngModel)]="dialogData.duration.months" required>
                        </div>

                        <div class="input-group-sm mb-3 input-group col">
                            <div class="input-group-prepend">
                                <span class="input-group-text form-label-105">Days</span>
                            </div>
                            <input class="form-control" name="days" type="text" [(ngModel)]="dialogData.duration.days"
                                required>
                        </div>
                    </div>

                    <div *ngIf="dialogData.type=='Fixed'" class="input-group">
                        <div class="input-group-sm mb-3 input-group col-11">
                            <div class="input-group-prepend">
                                <span class="input-group-text form-label-105">Date</span>
                            </div>
                            <input class="form-control" name="policy-date" [matDatepicker]="datePicker"
                                [(ngModel)]="dialogData.date" required>
                        </div>
                        <div class="col" style="bottom: 5px;">
                            <mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
                            <mat-datepicker #datePicker></mat-datepicker>
                        </div>
                    </div>

                    <div class="input-group-sm mb-3 input-group col-12">
                        <div class="input-group-prepend">
                            <span class="input-group-text form-label-105">Description</span>
                        </div>
                        <textarea class="form-control" name="description" type="text"
                            [(ngModel)]="dialogData.description" required></textarea>
                    </div>

                    <div style="float: right;">
                        <button mat-raised-button *ngIf="dialogData.button=='Create'" class="actionButton m-3"
                            (click)="createPolicyButton()"
                            [disabled]="!initiateForm.valid">{{dialogData.button}}</button>
                        <button mat-raised-button *ngIf="dialogData.button=='Update'" class="actionButton m-3"
                            (click)="updatePolicyButton()"
                            [disabled]="!initiateForm.valid">{{dialogData.button}}</button>
                        <button mat-raised-button class="backButton m-2" (click)="displayPage()">Back</button>
                    </div>
                </div>
            </form>
        </div>

        <div class="card mt-5" *ngIf="policyCreated">
            <div class="card-body">

                <div>Policy <strong>{{policyName}} </strong>has been created.</div>
                <button class="button-class" style="margin: 1em;" mat-raised-button
                    (click)="displayPage()">Back</button>

            </div>
        </div>
        <div class="card mt-5" *ngIf="policyUpdated">
            <div class="card-body">

                <div>Policy <strong>{{policyName}} </strong>has been updated.</div>
                <button class="button-class" style="margin: 1em;" mat-raised-button
                    (click)="displayPage()">Back</button>

            </div>
        </div>
    </div>
</div>